<template>
  <div class="cart__footer">
    <div class="cart__footer-items">
      <div class="cart__footer-item subtotal">
        <span>Subtotal:</span>
        <span>{{ formatPrice(subTotal) }}</span>
      </div>
      <div class="cart__footer-item shipping text-sm">
        <span>Shipping:</span>
        <span v-if="!hasFreeShipping && estimatedShipping > 0">
          <span v-if="shippingStartsAt">Starts at </span>
          {{ formatPrice(estimatedShipping) }}
        </span>
        <span v-else>Free</span>
      </div>
    </div>

    <button class="cart__btn btn-wrapper btn--wide" type="submit">
      <span class="btn btn--primary btn-text">Proceed to Checkout</span>
      <span class="btn--primary btn-icon">
        <svg><use href="#arrow-ne"></use></svg>
      </span>
    </button>

    <!--<ul class="cart__footer-icons">
      <li class="cart__footer-icon">
        <svg class="icon">
          <use href="#smiley"></use>
        </svg>
        <span v-html="cartData.happiness_guarantee"></span>
      </li>
      <li class="cart__footer-icon">
        <svg class="icon">
          <use href="#truck"></use>
        </svg>
        <span v-html="cartData.shipping_time"></span>
      </li>
    </ul>-->
  </div>
</template>

<script setup>
  import { computed, toRefs } from 'vue';

  const props = defineProps({
    cart: {
      type: Object,
      default: ({})
    },

    cartData: {
      type: Object,
      default: ({}) 
    },

    cartHasSubscriptionProducts: {
      type: Boolean,
      default: false
    },

    hasFreeShipping: {
      type: Boolean,
      default: false
    }
  })

  const { cart, cartData, cartHasSubscriptionProducts } = toRefs(props)

  const subTotal = computed(() => {
    return cart.value.total_price
  })

  const singleServingsOnly = computed(() => {
    //return cart.value?.items?.every(item => item?.variant_options[1] === '1');
    return cart.value?.items?.every(item => item?.variant_options?.[1] === '1') ?? false;
  })

  const estimatedShipping = computed(() => {
    const country = window.Shopify.country !== 'US' ? window.Shopify.country : '';
    const currencyRate = window.Shopify.currency.rate;
    const rateKey = country ? `shippingRates${country}` : 'shippingRates';
    const rates = cartData.value[rateKey];

    if (singleServingsOnly.value && subTotal !== 'undefined') {
      return rates?.lowest_rate * currencyRate;
    } 

    if (cartHasSubscriptionProducts.value && rates?.subscription?.minimum !== null && subTotal !== 'undefined') {
      return subTotal.value < rates?.subscription?.minimum * currencyRate ? rates?.lowest_rate * currencyRate : 0;
    }

    return subTotal.value < rates?.onetime?.minimum * currencyRate ? rates?.lowest_rate * currencyRate : 0;
  });

  const shippingStartsAt = computed(() => {
    const country = window.Shopify.country !== 'US' ? window.Shopify.country : '';
    const rateKey = country ? `shippingRates${country}` : 'shippingRates';
    const rates = cartData.value[rateKey];
    
    if (rates?.enable_shipping_rate_starts_at) {
      return true;
    } 

    return false;
  });

  const formatPrice = (price) => {
    return window.formattedPrice(price/100)
  }
</script>